export default __webpack_public_path__ + "static/media/fuelEnDetail.07d0295c.jpg";